import { useNavigate } from 'react-router-dom';
import { 
  Package,
  ArrowsLeftRight,
  ChartBar,
  ShoppingCart,
  ArrowLeft,
  ArrowRight,
  Scissors,
  Circle
} from '@phosphor-icons/react';

const pacmanModules = [
  {
    id: 'cadastro',
    title: 'Cadastro de Produtos',
    description: 'Base para registrar e organizar os itens do estoque.',
    icon: Package,
    path: '/gestao/pacman/cadastro',
    color: '#1B4332'
  },
  {
    id: 'movimentacoes',
    title: 'Movimentações',
    description: 'Controle de entrada, saída, consumo e ajustes.',
    icon: ArrowsLeftRight,
    path: '/gestao/pacman/movimentacoes',
    color: '#2D6A4F'
  },
  {
    id: 'estoque',
    title: 'Estoque Atual',
    description: 'Visualização consolidada do saldo e situação dos produtos.',
    icon: ChartBar,
    path: '/gestao/pacman/estoque',
    color: '#40916C'
  },
  {
    id: 'compras',
    title: 'Compras',
    description: 'Reposição orientada por estoque mínimo e necessidade atual.',
    icon: ShoppingCart,
    path: '/gestao/pacman/compras',
    color: '#52B788'
  }
];

export const PacManSubHome = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/gestao');
  };

  const handleModuleClick = (module) => {
    navigate(module.path);
  };

  return (
    <div className="min-h-screen bg-[#F7F6F4]" data-testid="pacman-page">
      <div className="salonup-container">
        {/* Header */}
        <header className="salonup-header animate-fade-in">
          <div className="salonup-brand">
            <div className="salonup-logo-mark">
              <Scissors size={22} weight="bold" />
            </div>
            <span className="salonup-logo-text">
              Salon<span>Up</span>
            </span>
          </div>
          
          <button 
            onClick={handleBack}
            data-testid="btn-back"
            className="salonup-btn-back"
          >
            <ArrowLeft size={18} weight="bold" />
            <span>Voltar para Gestão</span>
          </button>
        </header>

        {/* Breadcrumb */}
        <div className="mb-4 animate-fade-in opacity-0 delay-100" style={{ animationFillMode: 'forwards' }}>
          <p className="salonup-text-xs">
            <span 
              className="cursor-pointer hover:text-[#1B4332] transition-colors"
              onClick={() => navigate('/')}
            >
              Home
            </span>
            <span className="mx-2">·</span>
            <span 
              className="cursor-pointer hover:text-[#1B4332] transition-colors"
              onClick={() => navigate('/gestao')}
            >
              Gestão
            </span>
            <span className="mx-2">·</span>
            <span className="text-[#18181B] font-medium">PAC MAN</span>
          </p>
        </div>

        {/* Title Section */}
        <section className="mb-10 md:mb-12 animate-fade-in-up opacity-0 delay-150" style={{ animationFillMode: 'forwards' }}>
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <div 
              className="w-14 h-14 rounded-2xl flex items-center justify-center"
              style={{ backgroundColor: '#52B78815' }}
            >
              <Package size={28} weight="regular" style={{ color: '#52B788' }} />
            </div>
            <div>
              <div className="flex items-center gap-3">
                <h1 className="salonup-heading-lg">
                  PAC MAN
                </h1>
                <span className="salonup-badge" style={{ backgroundColor: '#52B788' }}>ESTOQUE</span>
              </div>
              <p className="salonup-text-sm mt-1">
                Escolha a função que deseja acessar
              </p>
            </div>
          </div>
          <p className="salonup-text-body max-w-2xl mt-4">
            Controle de estoque do SalonUp com foco em organização, movimentação, saldo atual e reposição.
          </p>
        </section>

        {/* Modules Grid */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {pacmanModules.map((module, index) => {
            const Icon = module.icon;
            
            return (
              <div
                key={module.id}
                data-testid={`card-${module.id}`}
                onClick={() => handleModuleClick(module)}
                className="salonup-card p-7 min-h-[180px] animate-fade-in-up opacity-0"
                style={{ animationDelay: `${200 + (index * 80)}ms`, animationFillMode: 'forwards' }}
              >
                <div className="flex flex-col h-full justify-between relative z-10">
                  {/* Top section */}
                  <div className="flex items-start justify-between">
                    <div 
                      className="salonup-icon-wrapper salonup-icon-wrapper-sm"
                      style={{ backgroundColor: `${module.color}12` }}
                    >
                      <Icon size={24} weight="regular" style={{ color: module.color }} />
                    </div>
                    <ArrowRight 
                      size={20} 
                      weight="bold" 
                      className="salonup-arrow" 
                    />
                  </div>
                  
                  {/* Bottom section */}
                  <div className="mt-6">
                    <h3 className="salonup-heading-md mb-2">
                      {module.title}
                    </h3>
                    <p className="salonup-text-sm">
                      {module.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </section>

        {/* Stats Preview */}
        <section className="mt-10 animate-fade-in opacity-0" style={{ animationDelay: '600ms', animationFillMode: 'forwards' }}>
          <div className="salonup-card p-6 bg-gradient-to-r from-[#52B788]/5 to-transparent border-[#52B788]/20">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                <Circle size={8} weight="fill" className="text-[#52B788]" />
                <span className="salonup-text-xs font-medium text-[#52B788]">Sistema ativo</span>
              </div>
              <span className="salonup-text-xs text-[#A1A1AA]">·</span>
              <span className="salonup-text-xs text-[#71717A]">8 categorias de produtos configuradas</span>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="salonup-footer animate-fade-in opacity-0" style={{ animationDelay: '700ms', animationFillMode: 'forwards' }}>
          <p className="salonup-text-xs">
            SalonUp — O sistema operacional do salão moderno
          </p>
          <p className="salonup-text-xs">
            Gestão (CORE) · PAC MAN · 4 funções disponíveis
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PacManSubHome;
